import React, { useEffect, useState } from 'react';
import LogoAr from './images/logoar.png';
import LogoEn from './images/logo.webp';
import { InformationCircleIcon } from '@heroicons/react/24/outline';
import './css/mainviewnav.css';
import { CreditCardIcon, BanknotesIcon } from '@heroicons/react/24/outline';
import { Link } from 'react-router-dom';
import { useTranslation } from '../hooks/useTranslation';
import axios from 'axios';
import { API_URL, getUploadUrl } from '../config/api';

const MainViewNav = () => {
  const { t, language } = useTranslation();
  const [logoUrl, setLogoUrl] = useState(null);

  useEffect(() => {
    const fetchLogo = async () => {
      try {
        const res = await axios.get(`${API_URL}/api/settings/logo`);
        if (res.data?.logo) {
          setLogoUrl(getUploadUrl(res.data.logo));
        }
      } catch (err) {
        // fallback to bundled logo
        setLogoUrl(null);
      }
    };

    fetchLogo();
  }, []);

  const Logo = logoUrl || (language === 'ar' ? LogoEn : LogoEn);
  
  return (
    <div className='main-view-nav'>
        <div className='container-fluid'>
            <div className='main-view-nav-content'>
                <div className='view-branches-btn'>
                    <Link to="/branches">
                        <button><InformationCircleIcon className='icon' /></button>
                    </Link>
                </div>

                <div className="logo-content">
                    <div>
                        <h2> {t('nav.brandName')} </h2>
                        <ul>
                            <li> <CreditCardIcon className='icon' /></li>
                            <li> <BanknotesIcon className='icon' /></li>
                        </ul>
                    </div>
                    <img src={Logo} alt='Logo' className='logo' />
                </div>
            </div>
        </div>
    </div>
  )
}

export default MainViewNav